import { Component } from "react";
import { Card, Row, Col, Spinner, Button, Alert, Form } from "react-bootstrap";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { FaCheck, FaExclamationTriangle } from "react-icons/fa";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import logomarca from '../../assets/images/logo3_resize.png';
import logomarca2 from '../../assets/images/logomarca.png';

class OptinMedico extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingDados: true,
            loading: false,
            erro: "",
            sucesso: false,
            medico_dados: {},
            optinChecked: false,
        };

        this.handleOptinChange = this.handleOptinChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const uuid = this.props.router.params.uuid;

        if (uuid) {
            this.carregaDadosMedico(uuid);
        } else {
            this.setState({ loadingDados: false, erro: "UUID do médico não informado." });
        }
    }

    carregaDadosMedico = async (uuid) => {
        const config = {
            headers: { 'X-USERNAME': import.meta.env.VITE_X_USERNAME }
        };

        try {
            const response = await api.get(`/pessoas/prestadores/uuid/${uuid}/?tipo_modelo=aviso_comunicacao_medico`, config);
            this.setState({
                medico_dados: response.data || {},
                loadingDados: false,
                erro: "",
            });
        } catch (error) {
            let erro_msg = "Erro ao carregar dados. Tente novamente.";
            if (error.response?.status === 404) {
                erro_msg = "Médico não encontrado.";
            } else if (error.response?.status === 500) {
                erro_msg = "Servidor indisponível no momento.";
            }
            this.setState({ loadingDados: false, erro: erro_msg });
        }
    };

    handleOptinChange(e) {
        this.setState({ optinChecked: e.target.checked });
    }

    handleSubmit() {
        const MySwal = withReactContent(Swal);

        if (!this.state.optinChecked) {
            MySwal.fire({
                icon: 'warning',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Você precisa marcar a opção para confirmar sua preferência.'
            });
            return;
        }

        this.setState({ loading: true });

        const uuid = this.props.router.params.uuid;
        const config = {
            headers: { 'X-USERNAME': import.meta.env.VITE_X_USERNAME }
        };

        api.post(`/pessoas/prestadores/optin_medicos_recordati/${uuid}/`, {}, config)
            .then(() => {
                this.setState({ loading: false, sucesso: true });
                MySwal.fire({
                    icon: 'success',
                    showCloseButton: true,
                    title: 'Confirmado!',
                    html: 'Sua preferência foi registrada com sucesso.'
                });
            })
            .catch(error => {
                console.error('Erro ao registrar optin:', error);
                this.setState({ loading: false });
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Erro',
                    html: 'Houve um erro ao registrar sua preferência. Por favor, tente novamente.'
                });
            });
    }

    render() {
        const { loadingDados, loading, erro, sucesso, medico_dados, optinChecked } = this.state;

        if (loadingDados) {
            return (
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={6}>
                            <div className="text-center mt-5">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </Spinner>
                                <p className="mt-2">Carregando...</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }

        if (erro) {
            return (
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={6}>
                            <Alert variant="danger" className="mt-4">
                                <FaExclamationTriangle className="me-2" />
                                {erro}
                            </Alert>
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div className="container">
                <Row className="mt-4 align-items-center justify-content-center">
                    <Col sm={10} lg={6}>
                        <div className="mb-4 text-center">
                            <img src={logomarca} alt="Aditus Health" style={{ maxWidth: '120px' }} />
                        </div>

                        <Card className="cardDestaque">
                            <Card.Header>
                                <strong>Comunicações — Recordati</strong>
                            </Card.Header>
                            <Card.Body>
                                {sucesso ? (
                                    <Alert variant="success" className="m-0">
                                        <FaCheck className="me-2" />
                                        Sua preferência foi registrada com sucesso. Obrigado!
                                    </Alert>
                                ) : (
                                    <>
                                        {medico_dados.aviso_comunicacao && (
                                            <div className="mb-4" dangerouslySetInnerHTML={{ __html: medico_dados.aviso_comunicacao }} />
                                        )}

                                        <Form.Check
                                            type="checkbox"
                                            id="optin-comunicacoes"
                                            label={<strong>Sim, aceito receber comunicações da Recordati.</strong>}
                                            checked={optinChecked}
                                            onChange={this.handleOptinChange}
                                            style={{ cursor: "pointer" }}
                                            className="mb-4"
                                        />

                                        <div className="text-end">
                                            <Button
                                                variant="success"
                                                disabled={loading || !optinChecked}
                                                onClick={this.handleSubmit}
                                            >
                                                {loading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : (
                                                    <><FaCheck className="me-1" /> Confirmar</>
                                                )}
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </Card.Body>
                        </Card>

                        <div className="mt-5 text-center">
                            <p>
                                Powered by{' '}
                                <a href="https://aditushealth.com.br" target="_blank" rel="noreferrer">
                                    <img src={logomarca2} alt="Aditus Health" style={{ maxWidth: '60px' }} />
                                </a>
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(OptinMedico);
